import styled from 'styled-components'

export const TableWrapper = styled.div`
  width: 100%;
  .ant-table-wrapper {
    .ant-table {
      background: transparent;
      table {
        /* 表头表身锁栏样式 */
        >thead.ant-table-thead,
        >tbody.ant-table-tbody {
          .ant-table-cell-fix-left {
            background: var(--transparentMask-100) !important;
            &.ant-table-cell-fix-left-last {
              background: linear-gradient(90deg, var(--transparentMask-100) 0%, var(--transparentMask-100) calc(100% - 12px), var(--transparentMask-85) 100%) !important;
            }
          }
          .ant-table-cell-fix-right {
            background: var(--transparentMask-100) !important;
            &.ant-table-cell-fix-right-first {
              background: linear-gradient(-90deg, var(--transparentMask-100) 0%, var(--transparentMask-100) calc(100% - 12px), var(--transparentMask-85) 100%) !important;
            }
          }
        }
        >thead.ant-table-thead {
          >tr>th {
            flex-wrap: nowrap !important;
            box-sizing: border-box;
            border-bottom: 1px solid var(--black-85);
            padding: 8px;
            background: transparent;
            font-size: var(--fontsize-12);
            font-weight: var(--fontweight-bold);

            width: fit-content;
            height: 40px;

	          text-overflow: ellipsis !important;
	          white-space: nowrap !important;
	          overflow: hidden !important;
	
            &:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
              background-color: transparent;
            }

            /* 带有提示的表头th样式 */
            >.thContentStyle {
              .ant-typography {
                margin: 0;
                padding: 0;
                box-sizing: border-box;

                font-size:  var(--fontsize-12);
                line-height: 1;

                &.ant-typography-success {
                  color: var(--grass-100);
                  font-weight: normal !important;
                }
              }
            }
          }
        }
        >tbody.ant-table-tbody {
          overflow-y: auto !important;
          >tr {
            >td.ant-table-cell {
              padding: 8px;
              box-sizing: border-box;
              background: transparent;
              height: 40px;
              &.ant-table-row-expand-icon-cell,
              &.ant-table-selection-column {
                padding: 0 !important;
                background: transparent;
                .anticon {
                  transform: scale(.75);
                }
              }
              /* 透明背景表格HOVER交互样式 */
              &.ant-table-cell-row-hover {
                border-color: var(--black-15) !important;
                background: var(--white-100) !important;
                &.ant-table-cell-fix-left {
                  background: var(--white-100) !important;
                  &.ant-table-cell-fix-left-last {
                    background: linear-gradient(90deg, var(--white-100) 0%, var(--white-100) calc(100% - 12px), var(--white-85) 100%) !important;
                  }
                }
                &.ant-table-cell-fix-right {
                  background: var(--white-100) !important;
                  &.ant-table-cell-fix-right-first {
                    background: linear-gradient(-90deg, var(--white-100) 0%, var(--white-100) calc(100% - 12px), var(--white-85) 100%) !important;
                  }
                }
              }
            }
            /* 透明背景表格选中状态条样式 */
            &.ant-table-row-selected {
              background: var(--white-100) !important;
            }
            /* 打开状态的主表格数据条样式 */
            &.custom-row-selected {
              background: var(--white-100);
              color: var(--font-85);
              >td.ant-table-cell {
                border-bottom: 1px solid var(--black-light-185);
                &:nth-child(1),
                &:nth-child(2) {
                  border-color: transparent;
                }
                &:nth-child(3) {
                  letter-spacing: var(--size-xxxx-larger);
                  transition: var(--transition-faster);
                }
                /* 打开状态下的HOVER交互样式 */
                &.ant-table-cell-row-hover {
                  border-bottom: 1px solid var(--black-15);
                  &:nth-child(1),
                  &:nth-child(2) {
                    border-color: transparent !important;
                  }
                }
              }
              /* 打开+选中状态的主表格数据条样式 */
              &.ant-table-row-selected {
                background: var(--white-100);
                color: var(--font-85);
                >td {
                  border-bottom: 1px solid var(--sky-5);
                  &:nth-child(1),
                  &:nth-child(2) {
                    border-color: transparent;
                  }
                }
              }
            }

            /* 子表格默认样式 */
            &.ant-table-expanded-row {
              background: var(--white-100) !important;
              >td.ant-table-cell {
                background: var(--white-100) !important;
                /* 子表格样式 */
                table {
                  /* 子表格表头表身锁栏样式 */
                  >thead.ant-table-thead,
                  >tbody.ant-table-tbody {
                    .ant-table-cell-fix-left {
                      background: var(--white-100) !important;
                      &.ant-table-cell-fix-left-last {
                        background: linear-gradient(90deg, var(--white-100) 0%, var(--white-100) calc(100% - 12px), var(--white-85) 100%) !important;
                      }
                    }
                    .ant-table-cell-fix-right {
                      background: var(--white-100) !important;
                      &.ant-table-cell-fix-right-first {
                        background: linear-gradient(-90deg, var(--white-100) 0%, var(--white-100) calc(100% - 12px), var(--white-85) 100%) !important;
                      }
                    }
                  }
                  >tbody.ant-table-tbody {
                    >tr {
                      >td.ant-table-cell {
                        /* 子表格HOVER交互样式 */
                        &.ant-table-cell-row-hover {
                          border-color: var(--sky-15) !important;
                          background: var(--sky-light-185) !important;
                          &.ant-table-cell-fix-left {
                            background: var(--table-whiteMask-100) !important;
                            &.ant-table-cell-fix-left-last {
                              background: linear-gradient(90deg, var(--table-whiteMask-100) 0%, var(--table-whiteMask-100) calc(100% - 12px), var(--table-whiteMask-85) 100%) !important;
                            }
                          }
                          &.ant-table-cell-fix-right {
                            background: var(--table-whiteMask-100) !important;
                            &.ant-table-cell-fix-right-first {
                              background: linear-gradient(-90deg, var(--table-whiteMask-100) 0%, var(--table-whiteMask-100) calc(100% - 12px), var(--table-whiteMask-85) 100%) !important;
                            }
                          }
                        }
                        /* 子表格选中状态条样式 */
                        &.ant-table-row-selected {
                          background: var(--sky-light-185) !important;
                        }
                      }
                    }
                  }
                }
              }            
              /* 选中状态下的子表格交互样式 */
              .ant-table-wrapper {
                table {
                  >thead>tr>th {
                    box-shadow: inset 0 8px 18px -16px var(--black-light-185);
                  }
                }
                &.custom-row-selected {
                  table {
                    >thead>tr>th {
                      box-shadow: inset 0 8px 18px -16px var(--sky-15);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    /* 复杂表头表格 */
    &.complexTable {
      .ant-table-container table > thead > tr:first-child th:first-child,
      .ant-table-container table > thead > tr:first-child th:last-child {
        border-radius: 0 !important;
      }
      .ant-table {
          table {
            border: none !important;
            >thead.ant-table-thead {
              >tr:first-child>th{
                border-top: 1px solid var(--black-85);
              }
              >tr>th {
                border-bottom: 1px solid var(--black-85);
              }
            >tbody.ant-table-tbody {
              >tr >td.ant-table-cell {
                padding: 4px 8px;
                height: 32px !important;
              }
              >tr>td.ant-table-cell {
                border-bottom: 1px solid var(--border-table-hasrowspan-color);
              }
              >tr>td.ant-table-cell:not([rowspan]) {
                border-bottom: 1px solid var(--border-table-color)
              }
              &:has([rowspan="3"]) {
                >tr:nth-child(3n+1)>td.ant-table-cell {
                  border-bottom: 1px solid var(--border-table-hasrowspan-color);
                }
              }
              &:has([rowspan="10"]) {
                >tr:nth-child(10n+1)>td.ant-table-cell {
                  border-bottom: 1px solid var(--border-table-hasrowspan-color);
                }
              }
            }
          }
        }
      }
    }

    /* 多行集群表格 */
    &.hasRowspan {
      &.rowspan-10 {
        table {
          >tbody.ant-table-tbody {
            &:has([rowspan="10"]) {
              >tr:nth-child(10n)>td.ant-table-cell {
                border-bottom: 1px solid var(--border-table-hasrowspan-color);
              }
            }
          }
        }
      }
      .ant-table {
        table {
          >tbody.ant-table-tbody {
            >tr >td.ant-table-cell {
              padding: 4px 8px;
              height: 32px !important;
            }
            >tr:has(td[rowspan]) {
              >td.ant-table-cell:first-child {
                font-size: var(--fontsize-16);
                border-right: 1px solid var(--border-table-color) ;
                &.ant-table-cell-row-hover {
                  border-right: 1px solid var(--sky-15);
                }
              }
              >td.ant-table-cell:last-child {
                font-size: var(--fontsize-16);
                border-left: 1px solid var(--border-table-color) ;
                &.ant-table-cell-row-hover {
                  border-left: 1px solid var(--sky-15);
                }
              }
            }
          }
        }
      }
    }

    /* 当容器背景色为白色时 表格加上className='bgWhiteTable' */
    &.bgWhiteTable {
      table {
        /* 表头表身锁栏样式 */
        >thead.ant-table-thead,
        >tbody.ant-table-tbody {
          .ant-table-cell-fix-left {
            background: var(--white-100) !important;
            &.ant-table-cell-fix-left-last {
              background: linear-gradient(90deg, var(--white-100) 0%, var(--white-100) calc(100% - 12px), var(--white-85) 100%) !important;
            }
          }
          .ant-table-cell-fix-right {
            background: var(--white-100) !important;
            &.ant-table-cell-fix-right-first {
              background: linear-gradient(-90deg, var(--white-100) 0%, var(--white-100) calc(100% - 12px), var(--white-85) 100%) !important;
            }
          }
        }
        >tbody.ant-table-tbody {
          >tr {
            >td.ant-table-cell {
              /* 白背景表格HOVER交互样式 */
              &.ant-table-cell-row-hover {
                border-color: var(--sky-15) !important;
                background: var(--sky-light-185) !important;
                &.ant-table-cell-fix-left {
                  background: var(--table-whiteMask-100) !important;
                  &.ant-table-cell-fix-left-last {
                    background: linear-gradient(90deg, var(--table-whiteMask-100) 0%, var(--table-whiteMask-100) calc(100% - 12px), var(--table-whiteMask-85) 100%) !important;
                  }
                }
                &.ant-table-cell-fix-right {
                  background: var(--table-whiteMask-100) !important;
                  &.ant-table-cell-fix-right-first {
                    background: linear-gradient(-90deg, var(--table-whiteMask-100) 0%, var(--table-whiteMask-100) calc(100% - 12px), var(--table-whiteMask-85) 100%) !important;
                  }
                }
              }
            }
            /* 白背景表格选中状态条样式 */
            &.ant-table-row-selected {
              background: var(--sky-light-185) !important;
            }
          }
        }
      }
    }

  /* 表格分页样式 */
  .ant-pagination.ant-table-pagination {
    margin: 32px 0;

    .ant-pagination-item,
    .ant-pagination-item-link {
      display: flex;
      align-items: center;
      justify-content: center;

      padding: 6px;
      box-sizing: border-box;
      
      border-color: transparent;
      border-radius: 4px;
      background: transparent;

      font-size:  var(--fontsize-16);
      font-family: 'Arial Narrow';
    
      width: 32px !important;
      height: 32px !important;
      overflow: hidden;
    }

    .ant-pagination-item-active {
      border-color: var(--sky-15);
      border-radius: 4px;
      background: var(--table-whiteMask-100);
      
      color: var(--sky-100);
      font-weight: normal !important;
    }
  }
`